import { render, staticRenderFns } from "./horairetimetable.vue?vue&type=template&id=25bae966&"
import script from "./horairetimetable.vue?vue&type=script&lang=js&"
export * from "./horairetimetable.vue?vue&type=script&lang=js&"
import style0 from "./horairetimetable.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports